import { useGatewayQuery } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import {
  UserSmartHoldSettingsDocument,
  UserSmartHoldSettingsQuery,
} from "./__generated__/UserSmartHoldSettings.v2.generated";

export type UserFocusTimeSettings = NonNullable<
  UserSmartHoldSettingsQuery["currentUser"]
>["focusTimeSettings"];

export type UserTravelTimeSettings = NonNullable<
  UserSmartHoldSettingsQuery["currentUser"]
>["travelTimeSettings"];

export type UserLunchHoldSettings = NonNullable<
  UserSmartHoldSettingsQuery["currentUser"]
>["lunchHoldSettings"];

export type UserMeetingReliefSettings = NonNullable<
  UserSmartHoldSettingsQuery["currentUser"]
>["meetingReliefSettings"];

export type UserSmartHoldSettings = {
  focusTimeSettings: UserFocusTimeSettings;
  lunchHoldSettings: UserLunchHoldSettings;
  meetingReliefSettings: UserMeetingReliefSettings;
  travelTimeSettings: UserTravelTimeSettings;
};

export const useUserSmartHoldSettings = () => {
  const { data: smartHoldSettingsData, loading } = useGatewayQuery(UserSmartHoldSettingsDocument);

  let allSettings;

  if (smartHoldSettingsData?.currentUser) {
    allSettings = {
      focusTimeSettings: smartHoldSettingsData.currentUser.focusTimeSettings,
      lunchHoldSettings: smartHoldSettingsData.currentUser.lunchHoldSettings,
      meetingReliefSettings: smartHoldSettingsData.currentUser.meetingReliefSettings,
      travelTimeSettings: smartHoldSettingsData.currentUser.travelTimeSettings,
    };
  }

  return {
    loading,
    allSettings,
  };
};
